module.exports = __webpack_public_path__ + "img/9788926770214.16db84a1.jpg";